import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { register } from "./registrationAPI";
import { UserRegistration } from "./types";

export interface RegistrationState {
  status: "idle" | "loading" | "failed" | "succeeded";
}

const initialState: RegistrationState = {
  status: "idle",
};

export const registerAsync = createAsyncThunk(
  "registration/register",
  async (registration: UserRegistration) => {
    var result = await register(registration);
    return result;
  }
);

export const registrationSlice = createSlice({
  name: "registration",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(registerAsync.pending, (state) => {
        state.status = "loading";
      })
      .addCase(registerAsync.fulfilled, (state, action) => {
        state.status = "succeeded";
      })
      .addCase(registerAsync.rejected, (state, action) => {
        state.status = "failed";
      });
  },
});

// export const {} = eventsSlice.actions;

export default registrationSlice.reducer;
